module.exports = __webpack_public_path__ + "img/marker-oil-produce-red.5d00a43a.png";